import {CREATE_PRINT_REQUEST} from './actionTypes'

export const createPrint = (data) =>({
    type : CREATE_PRINT_REQUEST,
    payload : data
})

